import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Asset, AssetPhoto} from '../domain/item';
import {Contract} from '../domain/contract';

@Injectable({
  providedIn: 'root'
})
export abstract class ItemSummaryItemSummaryService {

  data = {
    asset: new Asset()
  };

  public assetServiceCallback: Subject<Asset> = new Subject<Asset>();
  public assetPhotoServiceCallback: Subject<Asset> = new Subject<Asset>();

  public abstract updateAssetInformation(asset): Observable<any>;

  public abstract updateSaleInformation(asset): Observable<any>;

  public abstract getItem(assetId: number): void;

  public abstract getContractInfo(itemId: number): Observable<Contract>;

  public abstract getItemPhotos(itemId: number): Observable<AssetPhoto>;
}
